import {ACTIVE_USER_ACTIONS} from "./types";
import {activeUser} from "../../system/types/activeUser/activeUserType";

export const setActiveUserToken = (token: string) => {
    return {
        type: ACTIVE_USER_ACTIONS.setActiveToken,
        payload: token,
    };
};

export const setActiveUserIsValid = (validity: boolean) => {
    return {
        type: ACTIVE_USER_ACTIONS.setUserIsValid,
        payload: validity,
    };
};

export const setActiveUserEmail = (email: string) => {
    return {
        type: ACTIVE_USER_ACTIONS.setEmail,
        payload: email,
    };
};

export const setActiveUserData = (userData: activeUser) => {
    return {
        type: ACTIVE_USER_ACTIONS.setUserData,
        payload: userData,
    };
};

export const clearActiveUser = () => {
    return {
        type: ACTIVE_USER_ACTIONS.clearData,
    };
};

